import { useEffect, useMemo, useState } from "react";
import { doctrineCoverPalette } from "../lib/doctrine-cover.js";

export function DoctrineCover({
  api,
  cover,
  title,
  authors = [],
  edition = null,
  seed,
  className = "",
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const palette = useMemo(
    () => doctrineCoverPalette(seed || `${title}-${authors.join("-")}`),
    [authors, seed, title],
  );

  useEffect(() => {
    let active = true;
    let objectUrl;
    setImageUrl(null);
    if (!cover?.available || !cover.url) return () => { active = false; };
    api.getDoctrineCover(cover.url)
      .then((blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [api, cover?.available, cover?.url]);

  const authorLabel = authors.join(", ") || "Autor no informado";
  const classes = `doctrine-cover${imageUrl ? " is-uploaded" : " is-generated"}${className ? ` ${className}` : ""}`;

  if (imageUrl) {
    return (
      <div className={classes}>
        <img src={imageUrl} alt={`Tapa de ${title}`} />
      </div>
    );
  }

  return (
    <div
      className={classes}
      style={{ backgroundColor: palette.backgroundColor, color: palette.color }}
      role="img"
      aria-label={`Tapa automática de ${title}, ${authorLabel}${edition ? `, ${edition}` : ""}`}
    >
      <div className="doctrine-cover-generated-copy">
        <span className="doctrine-cover-kind">Doctrina</span>
        <span className="doctrine-cover-rule" aria-hidden="true" />
        <strong>{title}</strong>
        <div>
          <span>{authorLabel}</span>
          {edition ? <small>{edition}</small> : null}
        </div>
      </div>
    </div>
  );
}
